import { RESOURCE_RATE } from 'enums/extensionShortIdEnum';
import { COLUMN_TYPES_ENUM, TIME_TYPE_COLUMNS, RATE_TYPE_COLUMNS } from 'modules/report/enums/columnTypeEnum';
import * as columnUnitTypes from 'modules/report/enums/columnUnitTypeEnum';

/**
 * @returns {Array}
 */
export default () => [
    {
        id: 'externalRemainingReportedBudgetCashAllTime',
        display: 'Budget Cash Remaining',
        unitType: columnUnitTypes.CURRENCY.value,
        displayTimeType: 'Reported',
        displayColumnType: 'budget',
        displayRateType: 'external rate',
        columnType: COLUMN_TYPES_ENUM.BUDGET,
        timeType: TIME_TYPE_COLUMNS.REPORTED,
        rateType: RATE_TYPE_COLUMNS.EXTERNAL,
        heatMapSupport: false,
    },
    {
        id: 'internalRemainingReportedBudgetCashAllTime',
        display: 'Budget Cash Remaining',
        unitType: columnUnitTypes.CURRENCY.value,
        displayTimeType: 'Reported',
        displayColumnType: 'budget',
        displayRateType: 'internal rate',
        extensions: [RESOURCE_RATE],
        columnType: COLUMN_TYPES_ENUM.BUDGET,
        timeType: TIME_TYPE_COLUMNS.REPORTED,
        rateType: RATE_TYPE_COLUMNS.INTERNAL,
        heatMapSupport: false,
    },
    {
        id: 'externalConsumedReportedBudgetCashAllTimePercentage',
        display: '% Budget Cash Consumed',
        unitType: columnUnitTypes.PERCENTAGE.value,
        displayTimeType: 'Reported',
        displayColumnType: 'budget',
        displayRateType: 'external rate',
        columnType: COLUMN_TYPES_ENUM.BUDGET,
        timeType: TIME_TYPE_COLUMNS.REPORTED,
        rateType: RATE_TYPE_COLUMNS.EXTERNAL,
        heatMapSupport: false,
    },
    {
        id: 'internalConsumedReportedBudgetCashAllTimePercentage',
        display: '% Budget Cash Consumed',
        unitType: columnUnitTypes.PERCENTAGE.value,
        displayTimeType: 'Reported',
        displayColumnType: 'budget',
        displayRateType: 'internal rate',
        extensions: [RESOURCE_RATE],
        columnType: COLUMN_TYPES_ENUM.BUDGET,
        timeType: TIME_TYPE_COLUMNS.REPORTED,
        rateType: RATE_TYPE_COLUMNS.INTERNAL,
        heatMapSupport: false,
    },
    {
        id: 'externalReportedBudgetCashAllTimeStatus',
        display: 'Budget Cash Status',
        displayTimeType: 'Reported',
        displayColumnType: 'budget',
        displayRateType: 'external rate',
        columnType: COLUMN_TYPES_ENUM.BUDGET,
        timeType: TIME_TYPE_COLUMNS.REPORTED,
        rateType: RATE_TYPE_COLUMNS.EXTERNAL,
        heatMapSupport: false,
    },
    {
        id: 'internalReportedBudgetCashAllTimeStatus',
        display: 'Budget Cash Status',
        displayTimeType: 'Reported',
        displayColumnType: 'budget',
        displayRateType: 'internal rate',
        extensions: [RESOURCE_RATE],
        columnType: COLUMN_TYPES_ENUM.BUDGET,
        timeType: TIME_TYPE_COLUMNS.REPORTED,
        rateType: RATE_TYPE_COLUMNS.INTERNAL,
        heatMapSupport: false,
    },
    {
        id: 'remainingReportedBudgetHoursAllTime',
        display: 'Budget Hours Remaining',
        unitType: columnUnitTypes.CURRENCY.value,
        displayTimeType: 'Reported',
        displayColumnType: 'budget',
        columnType: COLUMN_TYPES_ENUM.BUDGET,
        timeType: TIME_TYPE_COLUMNS.REPORTED,
        heatMapSupport: false,
    },
    {
        id: 'consumedReportedBudgetHoursAllTimePercentage',
        display: '% Budget Hours Consumed',
        unitType: columnUnitTypes.PERCENTAGE.value,
        displayTimeType: 'Reported',
        displayColumnType: 'budget',
        columnType: COLUMN_TYPES_ENUM.BUDGET,
        timeType: TIME_TYPE_COLUMNS.REPORTED,
        heatMapSupport: false,
    },
    {
        id: 'reportedBudgetHoursAllTimeStatus',
        display: 'Budget Hour Status',
        unitType: columnUnitTypes.CURRENCY.value,
        displayTimeType: 'Reported',
        displayColumnType: 'budget',
        columnType: COLUMN_TYPES_ENUM.BUDGET,
        timeType: TIME_TYPE_COLUMNS.REPORTED,
        heatMapSupport: false,
    },
];
